import { ModuleWithProviders, NgModule, Optional, SkipSelf } from '@angular/core';
import { INGXLoggerConfig, LoggerModule } from 'ngx-logger';
import { CommonConfig } from './models/common.config';
import { LoggerProvider } from './services/logger-provider.service';
import { Logger } from './services/logger.service';
import { LOGGER_DEFAULT_CONFIG } from './variables';


@NgModule({
  declarations: [],
  imports: [
    LoggerModule
  ],
  providers: [
    Logger
  ]
})
export class SIGVCommonModule {

  constructor(
    @Optional() @SkipSelf() parentModule: SIGVCommonModule,
    loggerFactory: LoggerProvider) {
    if (parentModule) {
      throw new Error(`${new.target.name} is already loaded. Import in your base AppModule only.`);
    }
  }

  static forRoot(config: CommonConfig): ModuleWithProviders<SIGVCommonModule> {
    const loggerConfig: INGXLoggerConfig = {
      ...LOGGER_DEFAULT_CONFIG,
      ...config.loggerConfig
    };

    return {
      ngModule: SIGVCommonModule,
      providers: [
        ...(LoggerModule.forRoot(loggerConfig).providers ?? [])
      ]
    }
  }
}
